var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 0,
    y: 0,
    width: 38.059,
    height: 38.081,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_12",
    "data-name": "Mask Group 12",
    transform: "translate(-324 -213)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14962",
    "data-name": "Path 14962",
    d: "M16.825,14.852l-3.959-.993v-.987a5.7,5.7,0,0,0,1.98-2.97,1.277,1.277,0,0,0,.99-.99V6.93c.045-.353.231-.722,0-.99-.137-.154-.8.072-.99,0V3.963h.99a2.464,2.464,0,0,0,0-2.97C15.208.036,13.35,0,11.876,0a5.453,5.453,0,0,0-2.97.993c-3.561.077-3.96,1.356-3.96,2.97,0,.376-.06,1.47,0,1.98-.215.068.154-.173,0,0-.238.27-1.034.634-.989.987l.99,1.98a1.148,1.148,0,0,0,.989.993c.173,1.15.182,2.135.99,2.97v.987l-2.97.993A5.531,5.531,0,0,0,0,19.8c0,.231-.231,0,0,0H19.795c.231,0,0,.231,0,0C19.795,17.641,18.922,15.377,16.825,14.852Z",
    transform: "translate(324.103 213.048)",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMens);
export default __webpack_public_path__ + "static/media/mens.6ad225e2e76773ec5ce1dea09c0e8e57.svg";
export { ForwardRef as ReactComponent };